<template>
  <v-data-table
    v-bind="$attrs"
    v-on="$listeners"

    :headers="headers"
    item-key="_id"
  >
    <template v-slot:item.actions="{ item }">
      <v-tooltip top>
        <template v-slot:activator="tooltipProps">
          <v-btn
            small
            icon
            color="primary"
            @click="() => copyId(item._id)"

            v-bind="tooltipProps.attrs"
            v-on="tooltipProps.on"
          >
            <v-icon small>
              mdi-content-copy
            </v-icon>
          </v-btn>
        </template>

        <template v-slot:default>
          Copiar _id
        </template>
      </v-tooltip>
    </template>

    <template v-slot:item.rate="{ item }">
      {{ formatPercentage(item.rate) }}
    </template>

    <template v-slot:item.quantity="{ item }">
      <span :class="{ 'error--text': item.quantity < 0 }">
        {{ formatNumber(item.quantity) }}
      </span>
    </template>

    <template v-slot:item.unitaryPrice="{ item }">
      {{ formatMoney(item.unitaryPrice) }}
    </template>

    <template v-slot:item.value="{ item }">
      <span :class="{ 'error--text': item.value < 0 }">
        {{ formatMoney(item.value) }}
      </span>
    </template>

    <template v-slot:item.returnValue="{ item }">
      <span :class="{ 'error--text': item.returnValue < 0 }">
        {{ formatMoney(item.returnValue) }}
      </span>
    </template>

    <template v-slot:item.returnDate="{ item }">
      {{ formatDate(item.returnDate) }}
    </template>

    <!-- <template v-slot:item.mtdPerf="{ item }">
      <span :class="{ 'error--text': item.mtdPerf < 0 }">
        {{ formatPerformance(item.mtdPerf) }}
      </span>
    </template>

    <template v-slot:item.ytdPerf="{ item }">
      <span :class="{ 'error--text': item.ytdPerf < 0 }">
        {{ formatPerformance(item.ytdPerf) }}
      </span>
    </template> -->

    <template v-slot:item.percValue="{ item }">
      <span :class="{ 'error--text': item.percValue < 0 }">
        {{ formatPercentage(item.percValue) }}
      </span>
    </template>
  </v-data-table>
</template>

<script>
import {
  formatMoney,
  formatDate,
  formatNumber,
  formatPercentage,
  formatPerformance,
} from '@/utils/format-utils';

import copyToClipboard from '@/utils/copy-to-clipboard';

export default {
  name: 'HoldingRepurchaseTable',

  inheritAttrs: false,

  data: () => ({
    headers: [
      {
        value: 'actions',
        text: 'Ações',
        sortable: false,
        groupable: false,
        width: '48px',
      },

      {
        value: 'book',
        text: 'Book',
      },

      {
        value: 'rate',
        text: 'Taxa',
        align: 'end',
      },

      {
        value: 'quantity',
        text: 'Quantidade',
        align: 'end',
      },

      {
        value: 'unitaryPrice',
        text: 'PU',
        align: 'end',
      },

      {
        value: 'value',
        text: 'Valor',
        align: 'end',
      },

      {
        value: 'returnValue',
        text: 'Valor de Retorno',
        align: 'end',
      },

      {
        value: 'returnDate',
        text: 'Data de Retorno',
      },

      // {
      //   value: 'mtdPerf',
      //   text: 'Atrib. Perf. Mensal',
      //   align: 'end',
      // },

      // {
      //   value: 'ytdPerf',
      //   text: 'Atrib. Perf. Anual',
      //   align: 'end',
      // },

      {
        value: 'percValue',
        text: '%PL',
        align: 'end',
      },
    ],
  }),

  methods: {
    formatMoney,
    formatDate,
    formatNumber,
    formatPercentage,
    formatPerformance,

    copyId(id) {
      try {
        copyToClipboard(id);

        this.$store.dispatch('notification', {
          text: `_id ${id} copiado com sucesso!`,
          status: true,
        });
      } catch (error) {
        this.$store.dispatch('notification', {
          text: `Não foi possível copiar o _id ${id}`,
          status: true,
          color: 'error',
        });
      }
    },
  },
};
</script>
